import type { Locale } from "@/i18n/config";
import { localeToIntl } from "@/i18n/config";
import {
  formatDateOnly as _formatDateOnly,
  formatDate as _formatDate,
  formatShortDate as _formatShortDate,
  formatRelativeDate as _formatRelativeDate,
  getTimeZoneLabel as _getTimeZoneLabel,
  formatDateWithZone as _formatDateWithZone,
} from "@donista/shared/utils/format-date";

function getIntlLocale(locale?: Locale | string): string {
  if (!locale) return "de-DE";
  return localeToIntl[locale as Locale] ?? "de-DE";
}

export function formatShortDate(
  date: string | Date | null | undefined,
  locale?: Locale | string,
): string | null {
  return _formatShortDate(date, getIntlLocale(locale));
}

export function formatDateOnly(dateString: string, locale?: Locale | string): string {
  return _formatDateOnly(dateString, getIntlLocale(locale));
}

export function formatDate(dateString: string, locale?: Locale | string): string {
  return _formatDate(dateString, getIntlLocale(locale));
}

export function formatRelativeDate(date: string | Date, locale?: Locale | string): string {
  return _formatRelativeDate(date, getIntlLocale(locale));
}

export function getTimeZoneLabel(dateString: string, locale?: Locale | string): string {
  return _getTimeZoneLabel(dateString, getIntlLocale(locale));
}

export function formatDateWithZone(dateString: string, locale?: Locale | string): string {
  return _formatDateWithZone(dateString, getIntlLocale(locale));
}
